import { LocaleConfig } from 'context/LocalisationContext';
import { de, enGB } from 'date-fns/locale';

export const AVAILABLE_LOCALES: Record<string, LocaleConfig> = {
  en: {
    messageFile: 'en',
    title: 'locale.en',
    localeCode: 'en-GB',
    publicationCode: 'en',
    dateFnsLocale: enGB,
  },
  de: {
    messageFile: 'de',
    title: 'locale.de',
    localeCode: 'de-DE',
    publicationCode: 'de',
    dateFnsLocale: de,
  },
};

// util method to return an array of locale -> config details
// used by the menu to list and change locales
export const getLanguages = () =>
  Object.entries(AVAILABLE_LOCALES).map(entry => {
    const code = entry[0];
    const config = entry[1];
    return { locale: code, entry: config };
  });
